/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Changelog1Inputs */

const id_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan perubahan`)
};

const ms_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log perubahan`)
};

const da_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog`)
};

const de_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll`)
};

const en_us2_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_es2_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_mx2_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng Pagbabago`)
};

const fr_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

const it_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche`)
};

const hu_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló`)
};

const nl_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek`)
};

const no_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg`)
};

const pl_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian`)
};

const pt_br2_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const pt_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações`)
};

const ro_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări`)
};

const fi_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki`)
};

const sv_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg`)
};

const vi_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi`)
};

const tr_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü`)
};

const cs_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените`)
};

const ru_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений`)
};

const uk_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін`)
};

const ar_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات`)
};

const hi_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग`)
};

const th_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const ja_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴`)
};

const zh_cn2_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const zh_hant1_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const ko_components_sandboxshell_changelog1 = /** @type {(inputs: Components_Sandboxshell_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Components_Sandboxshell_Changelog1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_changelog1 = /** @type {((inputs?: Components_Sandboxshell_Changelog1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Changelog1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_changelog1(inputs)
	if (locale === "ms") return ms_components_sandboxshell_changelog1(inputs)
	if (locale === "da") return da_components_sandboxshell_changelog1(inputs)
	if (locale === "de") return de_components_sandboxshell_changelog1(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_changelog1(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_changelog1(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_changelog1(inputs)
	if (locale === "fil") return fil_components_sandboxshell_changelog1(inputs)
	if (locale === "fr") return fr_components_sandboxshell_changelog1(inputs)
	if (locale === "it") return it_components_sandboxshell_changelog1(inputs)
	if (locale === "hu") return hu_components_sandboxshell_changelog1(inputs)
	if (locale === "nl") return nl_components_sandboxshell_changelog1(inputs)
	if (locale === "no") return no_components_sandboxshell_changelog1(inputs)
	if (locale === "pl") return pl_components_sandboxshell_changelog1(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_changelog1(inputs)
	if (locale === "pt") return pt_components_sandboxshell_changelog1(inputs)
	if (locale === "ro") return ro_components_sandboxshell_changelog1(inputs)
	if (locale === "fi") return fi_components_sandboxshell_changelog1(inputs)
	if (locale === "sv") return sv_components_sandboxshell_changelog1(inputs)
	if (locale === "vi") return vi_components_sandboxshell_changelog1(inputs)
	if (locale === "tr") return tr_components_sandboxshell_changelog1(inputs)
	if (locale === "cs") return cs_components_sandboxshell_changelog1(inputs)
	if (locale === "bg") return bg_components_sandboxshell_changelog1(inputs)
	if (locale === "ru") return ru_components_sandboxshell_changelog1(inputs)
	if (locale === "uk") return uk_components_sandboxshell_changelog1(inputs)
	if (locale === "ar") return ar_components_sandboxshell_changelog1(inputs)
	if (locale === "hi") return hi_components_sandboxshell_changelog1(inputs)
	if (locale === "th") return th_components_sandboxshell_changelog1(inputs)
	if (locale === "ja") return ja_components_sandboxshell_changelog1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_changelog1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_changelog1(inputs)
	return ko_components_sandboxshell_changelog1(inputs)
});
export { components_sandboxshell_changelog1 as "components.sandboxShell.changelog" }